import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { LifeFeatureConfig } from '../../../types/insurances/LifeFeatureConfig';
import { life as base } from './base';
import { life as AT } from './AT';
import { life as CZ } from './CZ';
import { life as HR } from './HR';
import { life as HU } from './HU';
import { life as RO } from './RO';
import { life as SK } from './SK';

export const lifeConfig: InsuranceIndex<LifeFeatureConfig> = { base, AT, CZ, HR, HU, RO, SK };
